<template>
    <div class="full-screen">
        <v-form class="grey lighten-4 ma-5">

            <v-text-field v-model="policy.insuredName" label="INSURED NAME"/>
            <v-layout row wrap ml-1>
                <v-flex lg3>
                    <v-text-field v-model="policy.streetAddress" value="12" label="Street Address"/>
                </v-flex>
                <v-flex lg3 ml-3>
                    <v-text-field v-model="policy.city" label="City"/>
                </v-flex>
                <v-flex lg2 ml-3>
                    <v-select
                            :items="this.$store.state.states"
                            v-model="policy.state"
                            item-text="name"
                            item-value="value"
                            label="State">
                    </v-select>
                </v-flex>
                <v-flex lg2 ml-3>
                    <v-text-field v-model="policy.zipCode"  mask="#####" label="Zip code"/>
                </v-flex>
            </v-layout>

            <v-text-field v-model="policy.carrier" label="CARRIER"/>
            <v-text-field v-model="policy.policyNum" label="POLICY#"/>
            <v-text-field v-model="policy.policyType" label="TYPE"/>

            <v-layout row wrap>
                <v-flex lg3 ml-1>
                    <v-text-field prefix="$" v-model="policy.premium" return-masked-value type="number" label="PREMIUM"/>
                </v-flex>

                <v-flex lg2 ml-3>
                    <v-text-field prefix="$" v-model="policy.fee"  return-masked-value type="number" label="Fee"/>
                </v-flex>

                <v-flex lg2 ml-3>
                    <v-text-field prefix="$" v-model="policy.commission" type="number" label="Commission"/>
                </v-flex>

                <v-flex lg3 m1-3>
                <v-menu
                        :close-on-content-click="false"
                        v-model="paidDateMenu"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                >
                    <v-text-field
                            slot="activator"
                            v-model="policy.paidDate"
                            label="Paid Date (read only text field)"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                    ></v-text-field>
                    <v-date-picker v-model="policy.paidDate" no-title
                                   @input="paidDateMenu = false"></v-date-picker>
                </v-menu>
                </v-flex>
            </v-layout>
            <v-menu
                    :close-on-content-click="false"
                    v-model="effectiveDateMenu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
            >
                <v-text-field
                        slot="activator"
                        v-model="policy.effectiveDate"
                        label="Effective Date (read only text field)"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                ></v-text-field>
                <v-date-picker v-model="policy.effectiveDate" no-title
                               @input="effectiveDateChanged"></v-date-picker>
            </v-menu>


            <v-menu
                    :close-on-content-click="false"
                    v-model="expirationDateMenu"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px">
                <v-text-field
                        slot="activator"
                        v-model="policy.expirationDate"
                        label="Expiration date (read only text field)"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                ></v-text-field>
                <v-date-picker v-model="policy.expirationDate" no-title
                               @input="expirationDateMenu = false"></v-date-picker>
            </v-menu>


            <v-select
                    :items="this.$store.state.wholesalers"
                    v-model="policy.wholeSeller"
                    item-text="name"
                    item-value="value"
                    label="WHOLESALER">
            </v-select>
            <v-btn color="primary" v-bind:to="{name: 'EmployeeHome'}">Cancel</v-btn>
            <v-btn color="primary" @click.prevent="updatePolicy">Save</v-btn>
        </v-form>
    </div>
</template>

<script>
    import {db} from '@/main'
    import moment from 'moment'

    export default {
        name: "EditPersonalPolicy",
        data() {
            return {
                effectiveDateMenu: false,
                expirationDateMenu: false,
                paidDateMenu: false,
                policy: {
                    id: null,
                    streetAddress: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    carrier: null,
                    effectiveDate: null,
                    expirationDate: null,
                    paidDate: null,
                    insuredName: null,
                    policyNum: null,
                    premium: null,
                    fee: null,
                    commission: null,
                    policyType: null,
                    wholeSeller: null
                }
            }
        },
        methods: {
            effectiveDateChanged() {
                this.effectiveDateMenu = false;

                var effectDateArray = this.policy.effectiveDate.split('-');
                var expireDateString = (effectDateArray[0] / 1 + 1).toString();
                this.policy.expirationDate = expireDateString.concat("-").concat(effectDateArray[1]).concat("-").concat(effectDateArray[2]);
            },
            updatePolicy() {
                Object.keys(this.policy).forEach((key) => {
                    if(this.policy[key] == null){
                        this.policy[key] = "";
                        console.log(key)
                    }
                });

                var effectDate = null
                var expirationDate= null
                var paidDate =null;

                if(this.policy.effectiveDate) {
                    var effectDateArray = this.policy.effectiveDate.split('-');
                    effectDate = new Date(effectDateArray[0], effectDateArray[1] - 1, effectDateArray[2]);
                }

                if(this.policy.expirationDate) {
                    var expirationDateArray = this.policy.expirationDate.split('-');
                    expirationDate = new Date(expirationDateArray[0], expirationDateArray[1] - 1, expirationDateArray[2]);
                }

                if(this.policy.paidDate) {
                    var paidDateArray = this.policy.paidDate.split('-');
                    paidDate = new Date(paidDateArray[0], paidDateArray[1] - 1, paidDateArray[2]);
                }

                db.collection("PERSONAL").doc(this.policy.id).set({
                    CARRIER: this.policy.carrier,
                    'EFFECTIVE DATE': effectDate,
                    'EXPIRATION DATE': expirationDate,
                    'PAID DATE': paidDate,
                    'INSURED NAME': this.policy.insuredName,
                    'POLICY#': this.policy.policyNum,
                    PREMIUM: this.policy.premium,
                    TYPE: this.policy.policyType,
                    WHOLESALE: this.policy.wholeSeller,
                    STREETADDRESS: this.policy.streetAddress,
                    CITY: this.policy.city,
                    STATE: this.policy.state,
                    ZIPCODE: this.policy.zipCode,
                    FEE: this.policy.fee,
                    COMMISSION: this.policy.commission
                })
                    .then(() =>
                        this.$router.push({name: 'EmployeeHome'})
                    )
            }
        },
        created() {
            db.collection("PERSONAL").doc(this.$route.params.pid).get().then((doc) => {
                var resData = doc.data();
                this.policy.id = doc.id;
                this.policy.address = resData.ADDRESS;
                this.policy.carrier = resData.CARRIER;

                if (resData['EFFECTIVE DATE']) {
                    this.policy.effectiveDate = moment(resData['EFFECTIVE DATE'].toDate()).format('YYYY-MM-DD');
                }
                if (resData['EXPIRATION DATE']) {
                    this.policy.expirationDate = moment(resData['EXPIRATION DATE'].toDate()).format('YYYY-MM-DD');
                }
                if (resData['PAID DATE']) {
                    this.policy.paidDate = moment(resData['PAID DATE'].toDate()).format('YYYY-MM-DD');
                }

                this.policy.streetAddress = resData.STREETADDRESS;
                this.policy.city= resData.CITY;
                this.policy.zipCode = resData.ZIPCODE;

                if(resData.STATE) {
                    this.policy.state = this.$store.state.states.filter(p => {
                        return p.value === resData.STATE
                    })[0];
                }
                this.policy.insuredName = resData['INSURED NAME'];
                this.policy.policyNum = resData['POLICY#'];
                this.policy.premium = resData.PREMIUM;
                this.policy.fee = resData.FEE;
                this.policy.commission = resData.COMMISSION;
                this.policy.policyType = resData.TYPE;
                this.policy.wholeSeller = resData.WHOLESALE;
            });
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/employee/insurance/EditPersonalPolicy.vue